import { BaseMultiText } from '../../../translation';
import { currentBuilderState } from '../builder.state';

import { updateSectionLabels } from './update-section-labels.function';

export function moveMetricUp(m: BaseMultiText): void {
    const state = currentBuilderState();

    const arr = state.viewParams.metrics;
    const index: number = arr.indexOf(m);
    const nIndex = Math.max(index - 1, 0);
    arr.splice(index, 1);
    arr.splice(nIndex, 0, m);

    updateSectionLabels();
}

export function moveMetricDown(m: BaseMultiText): void {
    const state = currentBuilderState();

    const arr = state.viewParams.metrics;
    const index: number = arr.indexOf(m);
    const nIndex = Math.min(index + 1, arr.length - 1);
    arr.splice(index, 1);
    arr.splice(nIndex, 0, m);

    updateSectionLabels();
}
